import { CrudOperators } from "@refinedev/core";

export const mapOperator = (operator: CrudOperators): string => {
  switch (operator) {
    case "ne":
      return `_${operator}`;
    case "gte":
    case "gt":
      return `_${operator}`;
    case "lt":
      return `_${operator}`;
    case "lte":
      return `_${operator}`;
    case "contains":
      return "_like";
    case "eq":
      return `_${operator}`;
    default:
      return "";
  }
};
